import { apiSlice } from "api/api.slice";
import { callToActionResultSchema } from "api/schemas/callToActionApiSchema";
import { toSearchString } from "api/utils";
import type { CallToActionResult } from "domains/callsToAction/types";

export type CallToActionArg = { topic_id?: string };

export const callToActionApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    callToAction: build.query<CallToActionResult, CallToActionArg>({
      providesTags: (_result, _error, arg) => [{ type: "CallToAction" as const, id: arg.topic_id }],
      query: ({ topic_id }) => `/call_to_action${toSearchString({ topic_id })}`,
      responseSchema: callToActionResultSchema,
    }),
  }),
});

export const { useCallToActionQuery } = callToActionApiSlice;
